import { useTranslation } from 'react-i18next'

import { FeedbackCard } from '../../components'

export const PasswordChangeRequest: React.FC = () => {
  const { t } = useTranslation('login')

  return <FeedbackCard title={t('passwordChangeRequestPage.title')} />
}
